import React from "react";
import { Typography } from '@mui/material';
import { LockOutlined as Icon } from '@mui/icons-material';

interface SupplierRetailerOnlyProps {
    isRetailer?: boolean;
    [key: string]: any;
}

function supplierOnlyCheck<P extends object>(WrappedComponent: React.ComponentType<P>){
    return (props: P & SupplierRetailerOnlyProps) => {
        const style = {fontSize: '16pt'};
        if(props.isRetailer){
            return <div style={{color: '#888'}}>
                <Icon style={{fontSize: "20em"}}/>
                <Typography style={style}>
                  Sorry, this page is only available to suppliers.
                </Typography>
            </div>;
        }
        return <WrappedComponent {...props as unknown as P} />;
    };
}

function retailerOnlyCheck<P extends object>(WrappedComponent: React.ComponentType<P>){
    return (props: P & SupplierRetailerOnlyProps) => {
        const style = {fontSize: '16pt'};
        if(!props.isRetailer){
            return <div style={{color: '#888'}}>
                <Icon style={{fontSize: "20em"}}/>
                <Typography style={style}>
                  Sorry, this page is only available to retailers.
                </Typography>
            </div>;
        }
        return <WrappedComponent {...props as unknown as P} />;
    };
}

const supplierOnly = <P extends object>(component: React.ComponentType<P>) => supplierOnlyCheck(component);
const retailerOnly = <P extends object>(component: React.ComponentType<P>) => retailerOnlyCheck(component);

export default supplierOnly;

export {supplierOnly, retailerOnly};
